import { createSlice } from '@reduxjs/toolkit';
import { getBreachStatusList } from './thunk';

const getOptionLabel = item => item?.name || item?.label || item?.description || item?._id || '';

export const initialState = {
    breachStatusList: [],
    breachStatusListSelect: [],
    isLoadingList: false,
    isSuccess: false,
};

const BreachStatusSlice = createSlice({
    name: 'BreachStatus',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getBreachStatusList.pending, state => {
            state.isLoadingList = true;
            state.isSuccess = false;
        });
        builder.addCase(getBreachStatusList.fulfilled, (state, action) => {
            const list = action.payload || [];
            state.breachStatusList = list;
            state.breachStatusListSelect = list.map(item => ({
                item,
                value: item._id,
                label: getOptionLabel(item),
            }));
            state.isLoadingList = false;
            state.isSuccess = true;
        });
        builder.addCase(getBreachStatusList.rejected, (state, action) => {
            state.error = action.payload || null;
            state.isLoadingList = false;
            state.isSuccess = false;
        });
    },
});

export default BreachStatusSlice.reducer;
